import React, { memo } from 'react';
import { clsx } from 'helpers/utils/HTMLUtils';
import './InformativoAssembleiasComVideo.scss';
import {
  BigPlayIcon,
  ChevronArrowRightIcon,
} from 'plataforma-fundacao-componentes';
const rootClassName = 'informativo-assembleias-com-video';

export enum InformativoAssembleiasComVideoAlign {
  Left = 'left',
  Center = 'center',
}

interface InformativoAssembleiasComVideoProps {
  onClick?: () => void;
  title?: string;
  subtitle?: string;
  imgUrl?: string;
  align?: InformativoAssembleiasComVideoAlign;
}

function InformativoAssembleiasComVideo(
  props: InformativoAssembleiasComVideoProps
) {
  return (
    <div className={rootClassName} onClick={props.onClick}>
      <div
        className={clsx([
          `${rootClassName}-first-row`,
          props.align ? `${props.align}` : '',
        ])}
      >
        <div
          className={`${rootClassName}-thumbnail`}
          style={{ backgroundImage: `url(${props.imgUrl})` }}
        />
        <div
          className={clsx([
            `${rootClassName}-play-icon`,
            props.align ? `${props.align}` : '',
          ])}
        >
          <BigPlayIcon />
        </div>
      </div>
      <div className={`${rootClassName}-saiba-mais-row`}>
        <div className={`${rootClassName}-icon`}>
          <ChevronArrowRightIcon />
        </div>
      </div>
      <div className={`${rootClassName}-title`}>{props.title}</div>
      <div className={`${rootClassName}-sub-title nunito`}>
        {props.subtitle}
      </div>
    </div>
  );
}

export default memo(InformativoAssembleiasComVideo);
